export default "__VITE_ASSET__BBKcDUBO__"